import { api } from '../apiConfig';

export const MAX_EXHIBITION_PHOTOS = 20;

// Let the browser set the multipart boundary. A bare
// "multipart/form-data" header makes the server see no file.
const withoutContentType = {
  transformRequest: [(data, headers) => {
    if (headers?.delete) headers.delete('Content-Type');
    else if (headers) delete headers['Content-Type'];
    return data;
  }]
};

/**
 * Upload photos to an exhibition and optionally choose one as the cover.
 * Returns the exhibition's photos after the upload.
 */
export const uploadExhibitionPhotos = async (exhibitionId, files, coverIndex = null) => {
  const form = new FormData();
  files.forEach((file) => form.append('photos', file));
  const response = await api.post(`/exhibitions/${exhibitionId}/photos`, form, withoutContentType);
  let photos = response.data?.photos || [];

  if (coverIndex !== null && files.length > 0) {
    const uploaded = photos.slice(-files.length);
    const cover = uploaded[coverIndex];
    if (cover && !cover.is_cover) {
      const coverResponse = await api.put(`/exhibitions/${exhibitionId}/photos/${cover.id}/cover`);
      photos = coverResponse.data?.photos || photos;
    }
  }

  return photos;
};
